<script setup>
import { swalError, swalSuccess } from '@/helper';
import { get_reward_actions } from '@/services/reward_actions';
import { onMounted, ref } from 'vue';
import rewardInput from './rewardInput.vue'


const isLoading = ref(true)
onMounted(async()=>{
  await parse_reward_actions()
  isLoading.value = false
})

const reward_actions = ref([])
async function parse_reward_actions(){
  let response = await get_reward_actions()
  console.log("🚀 ~ parse_reward_actions ~ response:", response)
  if (response.error){
    swalError(response.result, true)
    return
  }
  reward_actions.value = response.result.data.data
}


</script>

<template>
  <loadingCard v-if="isLoading" />
  <div v-else class="card">
    <CardHeader title="Point Setting"/>
    <div class="card-body">
      <rewardInput v-for="action in reward_actions"
        :key="action.id" 
        :reward_action="action" 
      />
      <!-- <div class="col-md-8">
        <div class="row mb-3">
          <label for="inputEmail3" class="col-sm-4 col-form-label">
            Point amount after 4 month
          </label>
          <div class="col-md-4">
            <input type="number" class="form-control" 
              id="inputEmail3"
            >
            <div class="form-text">
              Latest information to be displayed to client
            </div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>